
import './App.scss';
import Footer from './Components/Footer/Footer';
import Header from './Components/Header/Header';
import Nav from "./Components/Nav/Nav";
import RoutesList from './Routes';

function App() 
{
  return (
    <>
      <Header/>
      <main>
        <Nav/>
        <RoutesList/>
      </main>
      <Footer/>
    </>
  );
}

export default App;
